var React = require('react');

function CameraTripod24px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M13.243 14H9.77l5.811 8.427a1.009 1.009 0 0 1-.242 1.392.972.972 0 0 1-1.372-.246l-5.104-7.401V22c0 .552-.441 1-.985 1a.993.993 0 0 1-.985-1v-5.828l-5.104 7.401a.972.972 0 0 1-1.372.246 1.01 1.01 0 0 1-.242-1.392L5.986 14H2.514c-1.388 0-2.483-.661-2.483-2V5c0-1.339 1.095-3 2.483-3h1.785L4.782.657A.987.987 0 0 1 5.708 0h4.341c.414 0 .784.263.926.657L11.457 2h1.786c1.387 0 2.788 1.661 2.788 3v7c0 1.339-1.401 2-2.788 2zm.788-9c0-.228-.497-1-.788-1h-2.472l-.003.001a.956.956 0 0 1-.346-.072c-.033-.013-.063-.03-.095-.047a.945.945 0 0 1-.201-.138.845.845 0 0 1-.223-.29c-.015-.03-.035-.055-.047-.087-.003-.009-.01-.015-.013-.024L9.36 2H6.397l-.484 1.343c-.003.008-.01.013-.013.022-.028.072-.074.131-.117.193-.03.045-.052.096-.089.134-.046.049-.106.08-.161.119-.049.033-.092.075-.145.099-.053.024-.113.029-.17.043-.069.017-.134.04-.205.042-.009 0-.017.005-.025.005H2.514c-.291 0-.547.2-.547.428v7.143c0 .229.256.429.547.429h10.729c.291 0 .788.229.788 0V5zm-5.966 6c-1.664 0-3.018-1.346-3.018-3s1.354-3 3.018-3a3.012 3.012 0 0 1 3.018 3c0 1.654-1.353 3-3.018 3zm0-4c-.554 0-1.006.449-1.006 1 0 .551.452 1 1.006 1 .555 0 1.006-.449 1.006-1 0-.551-.451-1-1.006-1zM2.952 5h1.971v1H2.952V5z","key":1})]);
}

CameraTripod24px.displayName = "CameraTripod24px";

CameraTripod24px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 16.031 24"};

module.exports = CameraTripod24px;

CameraTripod24px.default = CameraTripod24px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/camera-tripod-24px.svg
// module id = 1262
// module chunks = 0